import React from "react";
import "./Muhammadabad.css";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Muhammadabad = () => {
  return (
    <div className="dp-page">

      <Helmet>
        <title>Aluminium & Window Works in Muhammadabad Gohna | Trusted Fabricators</title>
        <meta
          name="description"
          content="Find reliable aluminium window works in Muhammadabad Gohna. Skilled local fabricators provide sliding windows, doors, partitions, and custom aluminium solutions for homes and shops."
        />
        <meta
          name="keywords"
          content="Aluminium Windows Muhammadabad Gohna, Aluminium Doors, Sliding Windows, Aluminium Fabricators, Custom Aluminium Work, Window Installation"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Social */}
        <meta property="og:title" content="Aluminium & Window Works in Muhammadabad Gohna" />
        <meta
          property="og:description"
          content="Trusted aluminium fabricators providing sliding windows, doors, partitions, and custom solutions for homes and commercial properties in Muhammadabad Gohna."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Aluminium & Window Works in Muhammadabad Gohna" />
        <meta
          name="twitter:description"
          content="Skilled local aluminium fabricators providing sliding windows, doors, partitions, and custom aluminium solutions for homes and shops in Muhammadabad Gohna."
        />
      </Helmet>

      {/* 1️⃣ HERO SECTION */}
      <section className="dp-section">
        <div className="dp-container dp-split">
          <div>
            <h1>Aluminium & Window Works in Muhammadabad Gohna</h1>
            <p>
              Finding reliable aluminium window works in Muhammadabad Gohna is no longer difficult. With growing residential construction, new shop openings, and commercial renovations, the demand for skilled aluminium fabricators has increased steadily.
            </p>
          </div>
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765908421/WhatsApp_Image_2025-12-16_at_10.06.41_AM_mdtfzb.jpg"
            alt="aluminium-windows"
          />
        </div>
      </section>

      {/* 3️⃣ WHY ALUMINIUM WINDOWS */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Why Aluminium Windows and Doors Are a Smart Choice</h2>
          <p>
            Aluminium windows and doors are popular in Muhammadabad Gohna and nearby areas because they balance strength with a modern look. Unlike wood, aluminium does not warp, crack, or attract termites. It also handles heat, rain, and dust well, making it ideal for both homes and commercial spaces.
          </p>
          <p>
            Homeowners often choose aluminium sliding windows for better ventilation and easy maintenance, while shop owners prefer glass-fitted aluminium doors that improve visibility and security. For offices and showrooms, aluminium partitions and fixed glass panels help create professional interiors without heavy construction.
          </p>
        </div>
      </section>

      {/* 4️⃣ TRUSTED FABRICATORS */}
      <section className="dp-section dp-box-layout">
        <img
          src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.30_PM_1_fynu60.jpg"
          alt="fabricators"
        />
        <div className="dp-box">
          <h2>Trusted Aluminium Fabricators</h2>
          <p>
            Local aluminium fabricators understand regional construction styles, budget expectations, and practical usage needs. Most workshops handle everything from on-site measurement to fabrication and installation, ensuring the final fitting is accurate and hassle-free.
          </p>
          <p>
            Many aluminium fabricators in Muhammadabad Gohna also work across nearby towns and surrounding villages, offering quick service and flexible scheduling. Because they operate locally, communication is easier, costs are reasonable, and after-service support is readily available.
          </p>
        </div>
      </section>

      {/* 5️⃣ SLIDING WINDOWS & DOORS */}
      <section className="cp-page">
        <section className="cp-scroll">
          <div className="cp-scroll-text">
            <h2>Aluminium Sliding Windows and Doors</h2>
            <p>
              Sliding aluminium windows are one of the most requested services in Muhammadabad Gohna. They save space, allow natural light, and give a neat, modern finish to any room. These windows are especially useful for kitchens, bedrooms, balconies, and bathrooms.
            </p>
            <p>
              For shops and commercial properties, aluminium sliding doors with glass panels create an open, welcoming look while maintaining safety. Many shop owners prefer aluminium framing because it supports larger glass panels without compromising strength.
            </p>
          </div>
          <div className="cp-scroll-img"></div>
        </section>
      </section>

      {/* 6️⃣ CUSTOM FABRICATION */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Custom Aluminium Fabrication and Glass Work</h2>
          <p>
            Every building has different requirements, and that is where custom aluminium fabrication becomes important. Local aluminium workers in Muhammadabad Gohna offer customized designs for window grills, safety grills, office partitions, ACP sheet work, and glass fittings.
          </p>
          <p>
            Whether it is a residential house in town or a commercial space in a nearby market area, custom aluminium work ensures proper fit, better finishing, and long-term durability. Many fabricators also provide repair and replacement services for damaged glass, locks, and sliding systems.
          </p>
        </div>
      </section>

      {/* 7️⃣ SERVICE AREAS */}
      <section className="dp-section">
        <div className="dp-container dp-box-layout">
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1766165233/Screenshot_2025-12-19_225650_raucxl.png"
            alt="service-areas"
          />
          <div className="dp-box">
            <h2>Serving Muhammadabad Gohna and Surrounding Areas</h2>
            <p>
              Aluminium window works are widely available not only within Muhammadabad Gohna but also across nearby towns, villages, and market areas. This makes it easy to arrange site visits, get accurate measurements, and complete installations without long waiting periods.
            </p>
            <p>
              Local service coverage helps builders, homeowners, and shop owners complete projects on time while staying within budget.
            </p>
          </div>
        </div>
      </section>

      {/* 8️⃣ CONTENT */}
      <section className="aluminium-content">
        <div className="container">

          <h1>Choosing Aluminium Window Works in Mohammadabad Gohna</h1>
          <p>
            Mohammadabad Gohna has rapidly developed into a trusted market for aluminium, UPVC, and steel fabrication services. With rising residential construction, new shop setups, and commercial renovations, the demand for skilled aluminium window fabricators and steel work specialists continues to grow.
          </p>

          <h2>Aluminium, UPVC & Steel Works in Mohammadabad Gohna</h2>
          <p>
            Mohammadabad Gohna has become a reliable destination for aluminium windows, UPVC window systems, rolling shutters, and steel fabrication works. From residential homes to commercial buildings, local fabricators offer customized solutions using quality materials, modern fittings, and professional installation.
          </p>

          <h2>Top Aluminium Window Grill Dealers in Mohammadabad Gohna</h2>
          <p>
            Aluminium window grills are widely preferred for their strength, security, and sleek appearance. Leading dealers in Mohammadabad Gohna provide custom-designed aluminium grills that are rust-free, low-maintenance, and suitable for homes, shops, offices, and commercial spaces.
          </p>

          <h2>Top UPVC Window Dealers in Mohammadabad Gohna</h2>
          <p>
            UPVC windows are in high demand due to their excellent sound insulation, thermal efficiency, and long service life. Trusted UPVC window dealers in Mohammadabad Gohna supply sliding, casement, and fixed windows designed to reduce noise and resist weather conditions.
          </p>

          <h2>Rolling Shutter Manufacturers in Mohammadabad Gohna</h2>
          <p>
            Rolling shutters play an essential role in protecting shops, warehouses, and commercial spaces. Reliable rolling shutter manufacturers in Mohammadabad Gohna offer manual and motorized shutters made from heavy-duty steel and aluminium.
          </p>

          <h2>Aluminium & Steel Fabrication in Mohammadabad Gohna</h2>
          <p>
            Local aluminium and steel fabricators specialize in custom fabrication work such as aluminium sliding windows and doors, steel gates, railings, frames, glass partitions, and structural work.
          </p>

          <h2>Top Hardware Dealers in Mohammadabad Gohna</h2>
          <p>
            Hardware dealers in Mohammadabad Gohna supply essential fittings and accessories required for aluminium, UPVC, and steel works, ensuring smooth operation, enhanced safety, and long-lasting performance.
          </p>

        </div>
      </section>

      {/* 9️⃣ CTA */}
      <section className="dp-cta">
        <h2>Book Your Aluminium Work Today</h2>
        <Link to="/contact"><button>Contact Us</button></Link>
      </section>

    </div>
  );
};

export default Muhammadabad;
